import gql from 'graphql-tag'

export default gql`query authMe {
  authMe {
    id
    fullName
    identDoc
  }
}`
